export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-white">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-flashlight-line text-white text-lg"></i>
                </span>
                <span className="text-lg font-bold font-heading">吃瓜每日大赛</span>
              </div>
              <p className="text-sm text-white/60 leading-relaxed">
                专注每日吃瓜最新爆料与今日黑料，覆盖娱乐圈瓜、网红八卦及最新吃瓜事件，实时追踪热门爆料动态，一手黑料吃瓜尽在此处。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading">快速导航</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '热点榜单', href: '#ranking' },
                  { label: '话题广场', href: '#topics' },
                  { label: '焦点专题', href: '#carousel' },
                  { label: '主题索引', href: '#index' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    className="text-sm text-white/50 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading">特色栏目</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '最新快讯', href: '#updates' },
                  { label: '媒体聚焦', href: '#media' },
                  { label: '常见问答', href: '#faq' },
                  { label: '读者评论', href: '#comments' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    className="text-sm text-white/50 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 font-heading">合作伙伴</h4>
              <p className="text-sm text-white/40 leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
              <div className="mt-4 flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-white/10 text-white/50 cursor-pointer hover:bg-primary-500 hover:text-white transition-colors">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-white/10 text-white/50 cursor-pointer hover:bg-primary-500 hover:text-white transition-colors">
                  <i className="ri-weibo-line text-sm"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-white/10 text-white/50 cursor-pointer hover:bg-primary-500 hover:text-white transition-colors">
                  <i className="ri-bilibili-line text-sm"></i>
                </span>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">
              &copy; 2020 - 2026 吃瓜每日大赛 版权所有 | 本站内容仅供娱乐参考，不构成任何建议
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-white/40 hover:text-white/70 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}